import SidebarStandard from '../../components/sidebars/SidebarStandard.vue';

export default {
  computed: {
    sidebarContent() {
      return {
        title: {
          description: 'Collecting Institution',
          icon: 'mdi-domain',
          link: 'CollectingInstitutionList',
        },
        items: [
          {
            title: 'Collecting Institution',
            icon: 'mdi-domain',
            link: 'collecting-institution.list',
          },
        ],
      };
    },
  },
  components: {
    SidebarStandard,
  },
};
